import InstantWin from "./instantWin.container";

export default InstantWin;
